// extracted by mini-css-extract-plugin
export default {"AddCommentContainer":"AddComment_AddCommentContainer__BQXt2","Logo":"AddComment_Logo__7kRiU","Input":"AddComment_Input__q9k6P","PostButton":"AddComment_PostButton__ki7GM"};